import React, { useContext, useState, useEffect } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useLocation, useNavigate } from 'react-router-dom';
import FormPermissionService from "../../Setup/controller/FormPermissionController/FormPermissionController";
import CreateSupplierPage from "../View/SupplierForms/CreateSupplier";
import SupplierContactPage from "../View/SupplierForms/SupplierContactList";
import SupplierDocumentListPage from "../View/SupplierForms/SupplierDocumentList";
import SupplierHistoryListPage from "../View/SupplierForms/SupplierHistoryList";
import SupplierNotesPage from "../View/SupplierForms/SupplierNotes";
import SupplierDiscountList from "../View/SupplierForms/SupplierDiscountList";
import PurchasingListPage from "../../Purchasing/View/PurchasingList";
import SupplierCostListPage from "./SupplierForms/SupplierCostList";
import SupplierReportPage from "./SupplierForms/SupplierReport";
import SupplierUserDefineFields from "./SupplierForms/SupplierUserDefineFields";
import Draggable from 'react-draggable';
import SupplierService from "../Controller/SupplierController";
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import HelpSite from "../../Common/HelpLink";
const MODULE_IDS = {
    Assets: 3,
    Parts: 4,
    Suppliers: 5,
    Quotations: 6,
    SalesOrders: 7,
    Purchasing: 8,
    Agreements: 9,
    Jobs: 10,
    Contacts: 15,
};
function SupplierDetail({ SupplierID, onClose, onSuccess, IsDiaries, CommunicationID }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const RoleID = localStorage.getItem('RoleID');
    const FormAction = "/AdministrationSetting";
    //FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [phone, setPhone] = useState();
    const [Email, setEmail] = useState();
    const [companyName, setCompany] = useState();
    const [isMinimized, setIsMinimized] = useState(false);
    const [supplierName, setSupplierName] = useState("Supplier Details");
    const [isLock, setIsLock] = useState(0);
    const UserID = localStorage.getItem("UserID");
    const [activeTab, setActiveTab] = useState(IsDiaries === "1" ? 'tab-quotation' : 'tab-customer');
    const [assignedModules, setAssignedModules] = useState(new Set());
    const [tabCount, setTabCount] = useState(0);
    const toggleMinimize = () => {
        setIsMinimized(!isMinimized);
    };
    useEffect(() => {

        if (SupplierID > 0) {
            setActiveTab(IsDiaries === "1" ? 'tab-quotation' : 'tab-customer');
            fetchSupplierDetail();
            fetchAssignedModules();
        }
        else {
            setSupplierName("Supplier Details");
        }

    }, [SupplierID]);
    const fetchSupplierDetail = async () => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            if (SupplierID > 0) {
                const SupplierDetail = await SupplierService.GetSupplierByID(redirectCallback, SupplierID);
                setSupplierName(SupplierDetail[0].vc_SupplierName); // Update this line to match your data structure
                setPhone(SupplierDetail[0].vc_Phone);
                setEmail(SupplierDetail[0].vc_Email);
                setCompany(SupplierDetail[0].vc_SupplierName);
                debugger;
                if (SupplierDetail[0].isLock === 1 && SupplierDetail[0].LockBy != UserID) {
                    setIsLock(1);
                }
                else {
                    setIsLock(0);
                    await SupplierService.LockSupplier(SupplierID);
                }
            }
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }

    const handleTabClick = () => {
        setTabCount(prevCount => prevCount + 1); // Increment the count when any tab is clicked
    };
    const CompanyID = localStorage.getItem("CompanyID");
    const fetchAssignedModules = async () => {
        try {
            const modules = await ModuleService.GetRoleModules(redirectCallback, "en", CompanyID);
            const moduleSet = new Set(modules.map(m => m.PK_SearchModule_ID)); // Store assigned module IDs in a Set
            setAssignedModules(moduleSet);
        } catch (error) {
            console.error('Error fetching assigned modules:', error);
        }
    };
    const changeTab = (tab) => {
        setActiveTab(tab);
        handleTabClick(); // Increment count
    };
    const tabClass = (SupplierID > 0) ? "nav-link" : "nav-link disabled";
    return (
        <div className="modal fade supplierPopupModal show d-block" id="supplierPopupModal" tabIndex="-1" aria-labelledby="supplierPopupModalLabel" aria-hidden="true" data-backdrop="static">

            <div className="modal-dialog modal-xl">
                <Draggable handle=".modal-content" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                    bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{supplierName} <strong style={{ fontSize: "14px", color: "red" }}> {isLock.toString() === "0" ? "" : "(Locked)"}</strong></h5>
                            <span>
                                <button type="button" className="close" onClick={onClose} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <button type="button" className="close" onClick={toggleMinimize} aria-label="Minimize" >
                                    <span aria-hidden="true">{isMinimized ? '+' : '-'}</span>
                                </button>

                            </span>
                        </div>
                        {!isMinimized && (
                            <div className="modal-body" style={{ flex: "1" }}>
                                <div className="row vertical-pills-tab">
                                    <div className="d-flex justify-content-between align-items-center" style={{ marginLeft: "20px", marginRight: "25px", width: "100%", background: "#fff", borderBottom: "1px solid #d8e0e3" }}>
                                        <ul className="nav nav-tabs" style={{ border: "none", borderColor: "none" }}>
                                            <li className="nav-item">
                                                <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-customer' ? 'active' : ''}`} data-toggle="pill" href="#tab-customer" onClick={() => changeTab('tab-customer')}>
                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                        <img src="assets/img/resources/supp_details.png" style={{ width: "25px", height: "25px" }} />
                                                        <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Details</strong>
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-sites' ? 'active' : ''}`} data-toggle="pill" href="#tab-sites" onClick={() => changeTab('tab-sites')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/supp_contacts.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Contacts</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/supp_contacts.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Contacts</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-contacts' ? 'active' : ''}`} data-toggle="pill" href="#tab-contacts" onClick={() => changeTab('tab-contacts')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/supp_costs.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Costs</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/supp_costs.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Costs</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-discounting' ? 'active' : ''}`} data-toggle="pill" href="#tab-discounting" onClick={() => changeTab('tab-discounting')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/supp_discounts.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Disc...</strong>
                                                        </div></a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/supp_discounts.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Disc...</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>



                                            <li className="nav-item">
                                                {assignedModules.has(MODULE_IDS.Purchasing) && isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-costs' ? 'active' : ''}`} data-toggle="pill" href="#tab-costs" onClick={() => changeTab('tab-costs')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/supp_purchase-orders.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Purchase Orders".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/supp_purchase-orders.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Purchase Orders".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            {/* {isLock.toString() === "0" ? (
                                                <a className={tabClass} data-toggle="pill" href="#tab-udf">User Define Fields</a>
                                            ) : (
                                                <a className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                    User Define Fields
                                                </a>
                                            )}*/}
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-jobs' ? 'active' : ''}`} data-toggle="pill" href="#tab-jobs" onClick={() => changeTab('tab-jobs')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/supp_documents.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Docu...</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/supp_documents.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Docu...</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-quotation' ? 'active' : ''}`} data-toggle="pill" href="#tab-quotation" onClick={() => changeTab('tab-quotation')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/supp_comms-history.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Comms History".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/supp_comms-history.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Comms History".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-notes' ? 'active' : ''}`} data-toggle="pill" href="#tab-notes" onClick={() => changeTab('tab-notes')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/supp_notes.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Notes</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/supp_notes.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Notes</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>

                                        </ul>
                                        <div className="ml-auto">
                                            {activeTab === "tab-customer" && (
                                                <HelpSite FormName="Details" Module="6" />
                                            )}
                                            {activeTab === "tab-sites" && (
                                                <HelpSite FormName="Contact" Module="6" />
                                            )}
                                            {activeTab === "tab-contacts" && (
                                                <HelpSite FormName="Costs" Module="6" />
                                            )}
                                            {activeTab === "tab-discounting" && (
                                                <HelpSite FormName="Discounting" Module="6" />
                                            )}
                                            {activeTab === "tab-costs" && (
                                                <HelpSite FormName="Supplier Purchase Order" Module="6" />
                                            )}
                                            {activeTab === "tab-jobs" && (
                                                <HelpSite FormName="Documents" Module="6" />
                                            )}
                                            {activeTab === "tab-quotation" && (
                                                <HelpSite FormName="History" Module="6" />
                                            )}
                                            {activeTab === "tab-notes" && (
                                                <HelpSite FormName="Notes" Module="6" />
                                            )}
                                            {activeTab === "tab-reports" && (
                                                <HelpSite FormName="Report" Module="3" />
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-12 pl-0">
                                        <div className="tab-content p-3" id="v-pills-tabContent">
                                            <div className={`tab-pane fade ${activeTab === 'tab-customer' ? 'show active' : ''}`} id="tab-customer" role="tabpanel">
                                                <CreateSupplierPage SupplierID={parseInt(SupplierID, 10)} isLock={isLock} onClose={onClose} Tab={tabCount} />
                                            </div>
                                            {SupplierID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-sites' ? 'show active' : ''}`} id="tab-sites" role="tabpanel">
                                                    <SupplierContactPage SupplierID={parseInt(SupplierID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {SupplierID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-contacts' ? 'show active' : ''}`} id="tab-contacts" role="tabpanel">

                                                    <SupplierCostListPage SupplierID={parseInt(SupplierID, 10)} isLock={isLock} />

                                                </div>
                                            )}

                                            {SupplierID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-discounting' ? 'show active' : ''}`} id="tab-discounting" role="tabpanel">
                                                    <SupplierDiscountList SupplierID={parseInt(SupplierID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {SupplierID > 0 && assignedModules.has(MODULE_IDS.Purchasing) && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-costs' ? 'show active' : ''}`} id="tab-costs" role="tabpanel">
                                                    <PurchasingListPage ClientCompanyID={parseInt("0")} SupplierID={parseInt(SupplierID, 10)} isLock={isLock} />

                                                </div>
                                            )}
                                            {SupplierID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-udf' ? 'show active' : ''}`} id="tab-udf" role="tabpanel">
                                                    <SupplierUserDefineFields SupplierID={parseInt(SupplierID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {SupplierID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-jobs' ? 'show active' : ''}`} id="tab-jobs" role="tabpanel">
                                                    <SupplierDocumentListPage SupplierID={parseInt(SupplierID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {SupplierID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-quotation' ? 'show active' : ''}`} id="tab-quotation" role="tabpanel">
                                                    <SupplierHistoryListPage SupplierID={parseInt(SupplierID, 10)} isLock={isLock} Phone={phone} IsDiaries={IsDiaries} CommunicationID={CommunicationID} CompanyName={companyName} ToEmail={Email} Tab={tabCount} />
                                                </div>
                                            )}
                                            {SupplierID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-notes' ? 'show active' : ''}`} id="tab-notes" role="tabpanel">
                                                    <SupplierNotesPage SupplierID={parseInt(SupplierID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {SupplierID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-reports' ? 'show active' : ''}`} id="tab-reports" role="tabpanel">
                                                    <SupplierReportPage SupplierID={parseInt(SupplierID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default SupplierDetail;
